var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-select"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{class:`tab ${_vm.selectedIndex === index ? ' selected' : ''}`,on:{"click":function($event){return _vm.selectTab(tab, index)}}},[_c('span',[_vm._v(_vm._s(tab))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }